import React, { useState } from 'react';
import { Spinner } from 'telstra-ui/components/spinner/spinner';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { Button } from 'telstra-ui/components/button/Button';
import {
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS_IN_USE,
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS_NOT_IN_USE,
  PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS,
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS,
} from '../../../../app-constants';
import { formatPhoneNumber } from '../../../ffwd-homepage/ffwd-homepage.actions';
import './number-pill-drop-down.css';


const NumberPillDropDown = (props) => {
  const {
    planTableData: {
      tableHeading,
      siosText,
      planDetails,
      totalText,
      expandAllText,
      collapseAllText,
      moveToText,
      showMoreText,
      showLessText,
      showMoreCountValue,
    },
    showHideNumbersSection,
    handlePlansShowHide,
    tableType,
    expandedFeature,
    handleNumberSelection,
    selectedPlanNumberArr,
    handleExpandCollapseAllPlans,
    tableExpandCollapse,
    dropDown,
    dropDownNumber,
    setDropDownNumber,
    movePlan,
    serviceNumbersWithFlag,
    optimizeInProgress,
    customNumberBadgeClass,
    dropDownPosition,
    planCheckboxVal,
    onChangePlanCheckBox,
    setServiceDropdownRef,
  } = props;

  const [showMore, setShowMore] = useState(true);

  const planListDropDown = number => planDetails.map((plan, index) => {
    if ((plan.dataOnly === 'all' || plan.dataOnly === true || plan.dataOnly === false)) {
      return (
        <li key={`drop-down-li-${index + 1}-${number}-`} className="number-drop-down-item">
          <button
            key={`drop-down-${index + 1}-${number}-`}
            onClick={() => movePlan(index, plan.planName)}
            type="button"
            className="btn-drop-down-item"
          >{`${moveToText} ${plan.planTitle}`}
          </button>
        </li>
      );
    }
    return '';
  });

  const getSelectedClass = (number) => {
    if (serviceNumbersWithFlag[number].inUse === true && selectedPlanNumberArr.includes(number)) {
      return PLAN_TABLE_ACCOUNT_SELECTED_CLASS_IN_USE;
    } else if (serviceNumbersWithFlag[number].inUse === false && selectedPlanNumberArr.includes(number)) {
      return PLAN_TABLE_ACCOUNT_SELECTED_CLASS_NOT_IN_USE;
    }
    return PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS;
  };

  const getPillIdentificationClass = (number) => {
    let pillIdentificationClass = '';
    if (serviceNumbersWithFlag !== undefined) {
      if (serviceNumbersWithFlag[number].ncServiceType) {
        pillIdentificationClass = 'nc-only';
      } else {
        pillIdentificationClass = serviceNumbersWithFlag[number].dataOnly ? 'data-plan' : 'vocie-plan';
      }
    }
    return pillIdentificationClass;
  };

  const numberBadge = (plan, planIndex) => plan.numbersOnPlan.map((number, index) => {
    const buttonId = number.replace(/\s+/g, '');
    const selectedClass = getSelectedClass(number);
    const pillIdentificationClass = getPillIdentificationClass(number);
    const inUseEnabled = (serviceNumbersWithFlag[number].inUse === true) ? 'in-use' : 'not-in-use';
    const dropDownTopValue = `${dropDownPosition}px`;
    return (
      <div key={`numberBadge-${buttonId}`} className="numberBadge-section" data-item-no={index + 1}>
        <button
          id={`${buttonId}-${tableType}`}
          className={`${selectedClass} ${inUseEnabled} ${customNumberBadgeClass} ${(plan.planName === 'removePlan') ? pillIdentificationClass : ''}`}
          onClick={() => handleNumberSelection(number, selectedClass, tableType, plan, planIndex)}
        >
          {pillIdentificationClass === 'data-plan' &&
            <SvgIcon name="icon-authentication-hotspot" className={`pill-icon-${inUseEnabled}`} />
          }
          {pillIdentificationClass === 'vocie-plan' &&
            <SvgIcon name="icon-mobiles-mobile" className={`pill-icon-${inUseEnabled}`} />
          }
          {pillIdentificationClass === 'nc-only' &&
            <SvgIcon name="icon-system-circle-filled" className="mobile-pill-blank-icon" />
          }
          {formatPhoneNumber(number)}
        </button>
        {dropDown && plan.planName !== 'unaddressableServices' && serviceNumbersWithFlag[number].origiPlanName !== 'unaddressableServices' &&
          <span
            id={number}
            className={`${(dropDownNumber === number) ? 'arrow-up-btn special-dropdown' : 'arrow-down-btn special-dropdown'} btn`}
            onClick={setDropDownNumber}
            role="button"
            tabIndex={0}
            enabled={plan.planName !== 'unaddressableServices'}
          />
        }
        {dropDown && (plan.planName === 'unaddressableServices' || serviceNumbersWithFlag[number].origiPlanName === 'unaddressableServices') &&
          <span
            id={number}
            className="special-lock special-dropdown"
            role="button"
            tabIndex={0}
            enabled={plan.planName !== 'unaddressableServices'}
          />
        }

        {dropDown && (dropDownNumber === number) &&
          <div className="dropdown-list" style={{ top: dropDownTopValue }} ref={setServiceDropdownRef}>
            <ul>
              {planListDropDown(number, planIndex)}
            </ul>
          </div>
        }
      </div>
    );
  });

  const expandAndShowMore = (plansLength, tableExpandCollapseStatus, tableTypeStatus) => {
    if (tableExpandCollapseStatus === false) {
      setShowMore(false);
    } else if (tableExpandCollapseStatus === true) {
      setShowMore(true);
    }
    handleExpandCollapseAllPlans(plansLength, tableExpandCollapseStatus, tableTypeStatus);
  };

  const showMoreAndScroll = (showStatus) => {
    setShowMore(showStatus);
    document.getElementById('plan-table-section').scrollIntoView();
  };

  const planTableData = (plans, title, siosTitle, showMoreCount, totalCount) => {
    const totalNumberPills = totalCount;
    const plansView = plans.map((planList, index) => {
      const isosCount = (planList.numbersOnPlan).length;
      const activeRowClass = (planList.numbersOnPlan.filter(val => selectedPlanNumberArr.includes(val))[0]) ? PLAN_TABLE_ACCOUNT_SELECTED_CLASS : '';
      const accntHideShow = (showHideNumbersSection[index] !== false);
      return (
        <React.Fragment key={planList.planName}>
          <div key={planList.planName + isosCount} className={`${activeRowClass} row table-row`}>
            {tableType && tableType === 'NewPlanTable' &&
              <div className="col-1">
                <Checkbox
                  id={`${planList.planName}-checkbox`}
                  checked={(planList.planName !== 'unaddressableServices' 
                    && planCheckboxVal[planList.planName])
                    || false}
                  onChange={event => onChangePlanCheckBox(event, index, planList.planName)}
                  disabled={planList.planName === 'unaddressableServices' || isosCount <= 0}
                />
              </div>
            }
            {tableType === 'NewPlanTable' &&
              <React.Fragment>
                <div className="col-5 plan-title-checkbox">
                  {planList.planTitle}
                </div>
                <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
                  {isosCount}
                </div>
                {expandedFeature && isosCount > 0 &&
                  <div className="col-4">
                    <button
                      onClick={() => handlePlansShowHide(index, tableType, !accntHideShow, true)}
                      type="button"
                      className={`${accntHideShow ? 'plans-hide-btn' : 'plans-show-btn'} btn`}
                    />
                  </div>
                }
              </React.Fragment>
            }
            {tableType === 'OldPlanTable' &&
              <React.Fragment>
                <div className="col-6 plan-title-checkbox">
                  {planList.planTitle}
                </div>
                <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
                  {isosCount}
                </div>
                {expandedFeature && isosCount > 0 &&
                  <div className="col-4">
                    <button
                      onClick={() => handlePlansShowHide(index, tableType, !accntHideShow, true)}
                      type="button"
                      className={`${accntHideShow ? 'plans-hide-btn' : 'plans-show-btn'} btn`}
                    />
                  </div>
                }
              </React.Fragment>
            }
          </div>
          {accntHideShow &&
            <div className="badge-account-section device-badge">{numberBadge(planList, index)}</div>
          }
        </React.Fragment>
      );
    });
    return (
      <div className="table">
        <div className="row table-row heading-section">
          <div className="col-6">
            {title}
          </div>
          <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
            {siosTitle}
          </div>
          {expandedFeature &&
            <div
              className="col-4 expand-text"
              onClick={() => expandAndShowMore(plans.length, tableExpandCollapse, tableType)}
              role="button"
              tabIndex="0"
            >
              <span className="table-expand-collapse-text">{tableExpandCollapse ? collapseAllText : expandAllText}</span>
              <button
                type="button"
                className={`${tableExpandCollapse ? 'plans-hide-btn' : 'plans-show-btn'} btn`}
              />
            </div>
          }
        </div>
        {(optimizeInProgress) ?
          <Spinner size="tl-spinner-large" />
          : plansView
        }
        {showMore && showMoreCount > 0 &&
          <div className="row table-row show-more-less">
            <div className="col-12 pl-sm-0">
              <Button
                variant="primary"
                onClick={() => setShowMore(false)}
                size="medium"
                icon="no-icon"
                className="show-more-btn-class"
              >
                {showMoreText} ({showMoreCount})
              </Button>
            </div>
          </div>
        }
        {showMore === false &&
          <div className="row table-row show-more-less">
            <div className="col-12 pl-sm-0">
              <Button
                variant="primary"
                onClick={() => showMoreAndScroll(true)}
                size="medium"
                icon="no-icon"
                className="show-more-btn-class"
              >
                {showLessText}
              </Button>
            </div>
          </div>
        }

        <div className="row table-row total-row">
          <div className="col-6">
            {totalText}
          </div>
          <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
            {totalNumberPills}
          </div>
        </div>
      </div>
    );
  };

  const planCountTotal = planDetails.length;
  const minimumCount = parseInt(showMoreCountValue, 10);
  const remainingCount = planCountTotal - minimumCount;

  const minimumPlanData = planDetails.slice(0, minimumCount);

  let totalCount = 0;
  planDetails.forEach((itm) => {
    totalCount += (itm.numbersOnPlan).length;
  });

  return (
    <React.Fragment>
      {showMore && remainingCount > 0 &&
        planTableData(minimumPlanData, tableHeading, siosText, remainingCount, totalCount)
      }
      {showMore && remainingCount <= 0 &&
        planTableData(planDetails, tableHeading, siosText, 0, totalCount)
      }
      {showMore === false &&
        planTableData(planDetails, tableHeading, siosText, remainingCount, totalCount)
      }
    </React.Fragment>
  );
};

export default NumberPillDropDown;
